import React, { useRef, useState } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';

const TheShift = () => {
  const ref = useRef(null);
  const [mousePos, setMousePos] = useState({ x: 50, y: 50 });

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    setMousePos({
      x: ((e.clientX - rect.left) / rect.width) * 100,
      y: ((e.clientY - rect.top) / rect.height) * 100,
    });
  };

  return (
    <section id="shift" ref={ref}
      className="relative py-32 overflow-hidden bg-dark border-t border-white/5"
      onMouseMove={handleMouseMove}>
      {/* Mouse-following spotlight */}
      <div className="absolute inset-0 pointer-events-none transition-all duration-300"
        style={{
          background: `radial-gradient(600px circle at ${mousePos.x}% ${mousePos.y}%, rgba(212,175,55,0.05) 0%, transparent 60%)`,
        }} />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_50%_50%,rgba(114,47,55,0.06)_0%,transparent_70%)]" />

      <div className="relative z-10 max-w-3xl mx-auto px-6 text-center">
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="text-wine-light tracking-[0.35em] uppercase text-xs mb-10 font-semibold">
          Der Wendepunkt
        </motion.p>

        <motion.blockquote
          initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }} transition={{ duration: 0.9 }}
          className="text-3xl md:text-4xl font-serif text-cream italic leading-snug mb-12">
          Doch solange du im Außen nach Antworten suchst, bleibst du in diesem{' '}
          <span className="text-wine-light" style={{ textShadow: '0 0 15px rgba(155,66,78,0.35)' }}>
            schmerzhaften Hin und Her
          </span>{' '}
          gefangen.
        </motion.blockquote>

        <div className="space-y-8 text-lg text-cream/65 font-light leading-relaxed">
          {[
            {
              delay: 0.3,
              text: 'Der Wendepunkt kommt in dem Moment, in dem du beginnst, dich selbst wirklich zu sehen. Dich selbst zu halten. Und dich bewusst für dich zu entscheiden.',
            },
            {
              delay: 0.5,
              highlight: true,
              text: 'Denn echte Liebe entsteht nicht aus Mangel oder Verzweiflung – sie erwächst aus innerer Klarheit, tiefem Selbstwert und radikaler Selbstliebe.',
            },
            {
              delay: 0.7,
              gold: true,
              text: 'Und genau hier beginnt dein Love Shift.',
            },
          ].map((block, i) => (
            <motion.p key={i}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }} transition={{ delay: block.delay, duration: 0.8 }}
              className={
                block.gold
                  ? 'text-2xl font-serif italic text-gold'
                  : block.highlight
                  ? 'text-cream font-serif italic text-xl'
                  : ''
              }
              style={block.gold ? { textShadow: '0 0 20px rgba(212,175,55,0.4)' } : {}}>
              {block.text}
            </motion.p>
          ))}
        </div>

        <motion.div initial={{ opacity: 0, scaleX: 0 }} whileInView={{ opacity: 1, scaleX: 1 }}
          viewport={{ once: true }} transition={{ duration: 1.5, delay: 0.8 }}
          className="w-full h-[1px] mt-16 origin-center"
          style={{ background: 'linear-gradient(to right, transparent, rgba(212,175,55,0.4), transparent)' }} />
      </div>
    </section>
  );
};

export default TheShift;